import React from "react";
import selectors from "selectors";
import { useSelector } from "react-redux";
import useTranslate from "hooks/use-translate-language";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel
} from "@mui/material";
import "./schedule-chat.scss";

const ChooseTopic = ({ topicCategory, setTopicCategory }) => {
  const topic_categories = useSelector(selectors.getChatTopics);
  const translate = useTranslate();

  return (
    <div className="topic-container">
      <FormControl component="fieldset" style={{ width: "100%" }}>
        <FormLabel component="legend" className="topic-title">
          {translate("chooseATopic")}
        </FormLabel>
        <RadioGroup
          aria-label={translate("chooseATopic")}
          name="topic-category"
          value={topicCategory}
          onChange={(e) => setTopicCategory(e.target.value)}
        >
          {topic_categories.map(t => (
            <FormControlLabel
              key={t.topic_id}
              value={t.topic_id}
              htmlFor={`topic-category-${t.topic_id}`}
              control={
                <Radio
                  inputProps={{
                    "aria-label": t.topic_name,
                    id: `topic-category-${t.topic_id}`
                  }}
                  sx={{
                    position: "absolute",
                    width: "1px",
                    height: "1px",
                    padding: 0,
                    margin: "-1px",
                    overflow: "hidden",
                    clip: "rect(0, 0, 0, 0)",
                    whiteSpace: "nowrap",
                    border: 0,
                  }}
                />
              }
              label={t.topic_name}
              className={`topic-radio-option ${topicCategory === t.topic_id ? 'selected' : ''}`}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default ChooseTopic;
